module.exports = __webpack_public_path__ + "static/images/home.8119522.png";